export default __webpack_public_path__ + "static/media/CASSIE_Pesquisa.439a634f.jpg";